import Link from 'next/link'
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid'
import { classNameDanger } from '@/components/common/styles'
import Panel from '@/components/common/Panel'

const AccountDangerZone = ({ className }: { className: string }) => {
  return (
    <div className={`${className} p-4`}>
      <Panel title="Danger zone">
        <div className="text-lg">Transfer account ownership</div>
        <p className="text-sm text-gray-500 dark:text-gray-400 pb-2">
          Transfer ownership of this account to another user.
        </p>
        <button type="button" className={`${classNameDanger}`}>
          <span className="flex justify-stretch">
            {'Transfer account'}
            <span className="px-1" />
            <ExclamationTriangleIcon className="h-4 w-4 mt-[3px]" />
          </span>
        </button>
        <div className="col-span-2 pt-3 pb-4">
          <Link href="#!">
            <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
              Read more about how we transfer an account
            </div>
          </Link>
        </div>
        <hr className="border border-dashed my-4" />
        <div className="text-lg">Delete account</div>
        <p className="text-sm text-gray-500 dark:text-gray-400 pb-2">
          Once you delete your account, there is no going back. Please be
          certain.
        </p>
        <button type="button" className={`${classNameDanger}`}>
          <span className="flex justify-stretch ">
            {'Delete account'}
            <span className="px-1" />
            <span>
              <ExclamationTriangleIcon className="h-4 w-4 mt-[3px]" />
            </span>
          </span>
        </button>
        <div className="col-span-2 pt-3 pb-4">
          <Link href="#!">
            <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
              Read more about how we delete an account
            </div>
          </Link>
        </div>
      </Panel>
    </div>
  )
}

export default AccountDangerZone
